import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { SharedService } from 'src/app/_shared/shared.service';
import { AuthService } from 'src/app/SayTS/auth.service';
import { Constants } from 'src/app/_consts/constants';
import { environment } from '../../environments/environment';
import { tr } from 'date-fns/locale';

@Component({
  selector: 'app-rep-header',
  templateUrl: './rep-header.component.html',
  styleUrls: ['./rep-header.component.scss']
})
export class RepHeaderComponent implements OnInit {

  languageOptions = [
    { value: 'cs', label: 'Čeština' },
    { value: 'en', label: 'English' },
    { value: 'de', label: 'Deutsch' }
  ];
  version = environment.version;

  constructor(
    public shared: SharedService,
    private router: Router,
    private auth: AuthService,
    public offcanvasService: NgbOffcanvas,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {}

  /**
   * Přístup do admin sekce — Admin nebo Reservation manager (r_close).
   */
  get isAdmin(): boolean {
    const rights = this.shared.rightsAll;
    if (!rights) return false;
    const baseRights = rights[Constants.MOD_BASE];
    return baseRights && !!baseRights.r_close
  }

  /**
   * Plný admin (smí editovat uživatele a lokace) — r_edit.
   */
  get isSuperAdmin(): boolean {
    const rights = this.shared.rightsAll;
    if (!rights) return false;
    const baseRights = rights[Constants.MOD_BASE];
    return baseRights && !!baseRights.r_edit
  }

  get userName(): string {
    return this.shared.login?.fullname || '';
  }

  /** Název firmy, pod kterou je přihlášený uživatel registrovaný (jen pro klienty). */
  get clientName(): string | null {
    return this.shared.login?.client?.name || null;
  }

  get currentLang(): string {
    return this.translate.currentLang || this.translate.defaultLang || 'cs';
  }

  openMenu(content: any): void {
    this.offcanvasService.open(content, { position: 'end' });
  }

  logout(): void {
    this.auth.logoutUser(true);
  }

  changeLanguage(lang: string): void {
    this.translate.use(lang);
    this.shared.storageSet('lang', lang);
  }
}
